<!-- ----------------------------------------------- -->
<template>
  <nav id="pcMapHeader" :class="getBackgroundColor">
    <v-row align="center" class="map_header pa-0">
      <v-tooltip right>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            small
            class="ml-4"
            @click="showAreaSearch"
            :disabled="disableAreaSearch"
            v-on="on"
          >
            <v-icon :class="getTextColor">search</v-icon>
          </v-btn>
        </template>
        <span>{{ text.search }}</span>
      </v-tooltip>
      <span class="subtitle-1" :class="getTextColor">{{ dispCenterTwon }}</span>
      <v-spacer></v-spacer>
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            small
            class="ml-2"
            @click="showCalendar"
            :disabled="disableCalendar"
            v-on="on"
          >
            <v-icon :class="getTextColor">calendar_today</v-icon>
          </v-btn>
        </template>
        <span>{{ text.calendar }}</span>
      </v-tooltip>
      <span class="ml-1 body-2" :class="getTextColor">{{ appDate }}</span>
      <span class="ml-1 font-weight-bold headline" :class="getTextColor">{{
        appTime
      }}</span>
      <span
        v-show="!isCurrent"
        class="ml-1 font-weight-bold headline brown--text"
        >{{ text.historyMode }}</span
      >
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn
            icon
            small
            @click="renew"
            :disabled="disableCalendar"
            v-on="on"
          >
            <v-icon :class="getTextColor">{{ updateIcon }}</v-icon>
          </v-btn>
        </template>
        <span>{{ text.update }}</span>
      </v-tooltip>
    </v-row>
  </nav>
</template>
<!-- ----------------------------------------------- -->
<script>
/**
 * 川の防災情報 PC用地図ヘッダ
 * MapHeader.vue
 * @author LIS
 */
import mixin from "./../../lib/mixin.js";
import Util from "./../../lib/util.js";
import PageLog from "./../../lib/pageLog.js";

export default {
  /** タグ名 */
  name: "map-pc-header",
  mixins: [mixin],
  data() {
    return {
      /** 文字列リソース */
      text: {
        search: "市町村名検索",
        calendar: "過去日付選択",
        update: "画面更新",
        historyMode: "(過去)",
      },
    };
  },
  computed: {
    /** 地図位置名 */
    cityName: {
      get() {
        var pref = this.$store.state.map.prefName;
        var town = this.$store.state.map.townName;
        return pref + town;
      },
    },
    /** ベースとなる観測日時 */
    baseTime: {
      get() {
        let returnTime = this.$store.state.app.appTime;
        if (this.isCurrent) {
          if (this.$store.state.radar.radarType == "xrain") {
            returnTime = this.$store.state.radar.radarXrainDate;
          } else {
            returnTime = this.$store.state.radar.radarCbandDate;
          }
        }
        return returnTime;
      },
    },
    /** 観測日 */
    appDate: {
      get() {
        return Util.formatDate24(this.baseTime, "YYYY/MM/DD");
      },
    },
    /** 観測時間 */
    appTime: {
      get() {
        return Util.formatDate24(this.baseTime, "HH:mm");
      },
    },
    /** 履歴表示 */
    isCurrent: {
      get() {
        return this.$store.state.app.isCurrent;
      },
    },
    /** 表示コンテンツ取得 */
    getContent: {
      get() {
        return this.$store.state.app.content;
      },
    },
    /** 履歴表示有無により背景色を判断する */
    getBackgroundColor: {
      get() {
        if (this.$store.state.app.isCurrent) {
          return "secondary";
        }
        return "brown lighten-3";
      },
    },
    /** 履歴表示有無により文字とアイコン色を判断する */
    getTextColor: {
      get() {
        if (this.$store.state.app.isCurrent) {
          return "success--text";
        }
        return "brown--text";
      },
    },
    /** 履歴表示有無によりアイコンを判断する */
    updateIcon: {
      get() {
        if (this.$store.state.app.isCurrent) {
          return "autorenew";
        }
        return "update";
      },
    },
    /** 検索ボタンの活性/非活性を制御する */
    disableAreaSearch: {
      get() {
        return !this.$store.getters["radar/isNotPlay"];
      },
    },
    /** カレンダーと更新ボタンの活性/非活性を制御する */
    disableCalendar: {
      get() {
        // 履歴動画再生状態による制御
        if (!this.$store.getters["radar/isNotPlay"] || !this.$store.getters["Telemeter/isNotPlay"]) {
          return true;
        }

        // 表示コンテンツによる制御
        if (
          this.getContent == "Inundation" ||
          this.getContent == "VcPoint" ||
          this.getContent == "VcDefault" ||
          this.getContent == "VcCustom"
        ) {
          return true;
        }
        return false;
      },
    },
    /** 表示中心市町村設定 */
    dispCenterTwon: {
      get() {
        if (
          this.$store.state.map.zoom >= this.$store.state.map.mapConfig.zoomCity
        ) {
          return this.$store.state.map.dispCenterTwon;
        } else {
          let pref = this.$store.state.map.prefName;
          let town = this.$store.state.map.townName;
          return pref + town;
        }
      },
    },
  },
  methods: {
    /** 住所検索ダイアログの表示/非表示 */
    showAreaSearch() {
      this.$store.commit(
        "map/setShowAreaSearch",
        !this.$store.state.map.showAreaSearch
      );
    },
    /** 観測日時指定ダイアログの表示/非表示 */
    showCalendar() {
      this.$store.commit(
        "map/setShowCalendar",
        !this.$store.state.map.showCalendar
      );
    },
    /** 観測日時更新 */
    renew() {
      // アクセスログ出力
      PageLog.log({
        page_log: "map",
        lat: this.$store.state.map.center[0],
        lon: this.$store.state.map.center[1],
        zm: this.$store.state.map.zoom,
        device_sb: this.$store.state.app.mode,
        fc_flg: this.$store.getters["app/isFldCtl"],
      });
      // レーダの履歴動画再生状態をリセット
      this.$store.commit("radar/resetHistoryPlay");
      // 過去画像動画状態をリセット
      this.$store.commit("Telemeter/resetHistoryPlay");
      this.$store.commit("Telemeter/resetHistoryPrintCurrentPicture");
      // ストアの観測日時更新
      this.$store.commit("app/renewTime");
      // 観測日時クエリパラメーターを削除
      this.replaceTmQuery();
      // 画面遷移時の保持日時を更新
      this.$store.commit("app/setRetentionTime", {
        flag: true,
      });
    },
  },
};
</script>
<!-- ----------------------------------------------- -->
<style lang="scss" scoped>
#pcMapHeader {
  z-index: 3000;
  width: 100%;
  height: 40px;
  .map_header {
    width: 100%;
    height: 100%;
  }
}
</style>
